import {
  SPARTACUS_DEFAULT_PAGE_SIZE,
  SPARTACUS_DEFAULT_SORT_BY,
  SPARTACUS_DEFAULT_SORT_DIR,
} from 'src/constants/spartacus'
import { getDefaultSpartacusDateRange } from './spartacusDateRange'

export function createInitialSpartacusPageState(now) {
  const { fromDate, toDate } = getDefaultSpartacusDateRange(now)

  return {
    fromDate,
    toDate,
    filters: {},
    page: 1,
    pageSize: SPARTACUS_DEFAULT_PAGE_SIZE,
    sortBy: SPARTACUS_DEFAULT_SORT_BY,
    sortDir: SPARTACUS_DEFAULT_SORT_DIR,
  }
}

export function setSpartacusDateRange(state, { fromDate, toDate }) {
  return {
    ...state,
    fromDate,
    toDate,
    page: 1,
  }
}

export function setSpartacusFilters(state, filters = {}) {
  return {
    ...state,
    filters,
    page: 1,
  }
}

export function setSpartacusPagination(state, { page, pageSize }) {
  return {
    ...state,
    page,
    pageSize: pageSize ?? state.pageSize,
  }
}

export function setSpartacusSort(state, { sortBy, sortDir }) {
  return {
    ...state,
    sortBy,
    sortDir,
    page: 1,
  }
}

export function buildSpartacusDataQueryParams(state) {
  const params = {
    fromDate: state.fromDate.toISOString(),
    toDate: state.toDate.toISOString(),
    sortBy: state.sortBy,
    sortDir: state.sortDir,
  }

  if (state.filters && Object.keys(state.filters).length > 0) {
    params.filters = JSON.stringify(state.filters)
  }

  return params
}

export function buildSpartacusStatsQueryParams(state) {
  return buildSpartacusDataQueryParams(state)
}

export function buildSpartacusQueryParams(state) {
  return {
    ...buildSpartacusDataQueryParams(state),
    page: state.page,
    pageSize: state.pageSize,
  }
}

export function buildSpartacusExportQueryParams(state) {
  return buildSpartacusDataQueryParams(state)
}
